<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <div *ngIf="false" class="layout-sidebar">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <app-config *ngIf="false"></app-config>
    <app-exit *ngIf="false"></app-exit>
    <div class="layout-mask"></div>
</div>